/**
 * Stock Transfer: units on an open transfer between two of the brand's own warehouses —
 * dispatched from one, not yet received at the other. They sit in no warehouse's on-hand, so
 * the Snapshot, DoH view and Inventory Health show them in a column of their own and count
 * them in stock and DoH. One label and wording for all three grids.
 */
export const STOCK_TRANSFER_LABEL = 'Stock Transfer';

export const STOCK_TRANSFER_TOOLTIP =
    'Stock sent from one of your warehouses to another, dispatched but not yet received. Counted in stock and DoH.';

/** Same wording for a single warehouse's column in the Internal pivot. */
export const STOCK_TRANSFER_TO_WAREHOUSE_TOOLTIP =
    'Stock sent to this warehouse from another of your warehouses, dispatched but not yet received. Counted in this warehouse’s DoH.';

/** Hide key for the column in every grid's column picker. Hiding never changes a number. */
export const STOCK_TRANSFER_HIDE_KEY = 'stockTransfer';
